import { delay } from 'q'
import { EndCustomer, EndCustomerFormValues, EndCustomerServiceInterface, ListResponse, SingleResponse } from '../types'
import { createFakeListResponse, createFakeSingleResponse } from './fakes/createFakeResponse'
import endCustomers from './fakes/endCustomers'

const createEndCustomerObject = (id: number, values: EndCustomerFormValues): EndCustomer => {
	return { id, ...values }
}

export default class EndCustomerService implements EndCustomerServiceInterface {
	public async search(value: string): Promise<ListResponse<EndCustomer>> {
		await delay(500)
		return createFakeListResponse(endCustomers.filter(customer => customer.name.toLowerCase().includes(value.toLowerCase())))
	}

	public async getAll(): Promise<ListResponse<EndCustomer>> {
		await delay(500)
		return createFakeListResponse(endCustomers)
	}

	public async getById(id: number): Promise<SingleResponse<EndCustomer>> {
		await delay(500)
		return { data: endCustomers.find(customer => customer.id === id) }
	}

	public async getByParentId(id: number): Promise<ListResponse<EndCustomer>> {
		await delay(500)
		return createFakeListResponse(endCustomers.filter(endCustomer => endCustomer.reseller_id === id))
	}

	public async delete(id: number): Promise<void> {
		await delay(500)
		const index = endCustomers.findIndex(customer => customer.id === id)
		endCustomers.splice(index, 1)
	}

	public async edit(id: number, values: EndCustomerFormValues): Promise<SingleResponse<EndCustomer>> {
		await delay(500)
		const index = endCustomers.findIndex(endCustomer => endCustomer.id === id)
		const endCustomer = createEndCustomerObject(id, values)
		endCustomers.splice(index, 1, endCustomer)
		return createFakeSingleResponse(endCustomer)
	}

	public async create(values: EndCustomerFormValues): Promise<SingleResponse<EndCustomer>> {
		await delay(500)
		const id = Math.floor(Math.random() * 100)
		const endCustomer = createEndCustomerObject(id, values)
		endCustomers.push(endCustomer)
		return createFakeSingleResponse({ id: Math.floor(Math.random() * 100), ...endCustomer })
	}
}
